import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeading({ title, subtitle, icon, action }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-start gap-3">
        {icon ? (
          <span className="w-9 h-9 shrink-0 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
            <i className={`${icon} text-lg`}></i>
          </span>
        ) : (
          <span className="mt-1.5 w-1.5 h-6 shrink-0 rounded-full bg-accent-500"></span>
        )}
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-tight">{title}</h2>
          {subtitle ? <p className="mt-1 text-sm text-foreground-600">{subtitle}</p> : null}
        </div>
      </div>
      {action}
    </div>
  );
}